<template>
  <div
    class="d-flex align-items-start justify-content-center flex-column"
    id="app"
  >
    <NavBar style="width: 100%" />
    <div class="row app-body ml-0 mr-0 mb-2">
      <div
        v-if="$store.getters.user != null"
        class="navbar-expand-xl navbar-light mt-2 divider-right pl-2 pr-2 pt-2 text-right"
      >
        <div style="position: sticky; top: 1rem;">
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#sideNavCollapse"
            aria-controls="sideNavCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i id="navbarToggler" class="material-icons">
              menu
            </i>
          </button>
          <SideNav />
        </div>
      </div>
      <div class="col" v-bind:class="{ 'mt-4': $store.getters.user != null }">
        <router-view />
        <div id="snackbar" />
      </div>
      <button
        v-on:click="goToTop"
        class="btn btn-info"
        id="topBtn"
        title="Go to top"
      >
        Go to Top
      </button>
    </div>
    <Footer v-if="$route.path != '/instructions'" />
    <Loader v-if="$store.getters.loading" />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import Loader from "@/components/Loader";
import SideNav from "@/components/SideNav";
import Footer from "@/components/Footer";
import $ from "jquery";
export default {
  components: {
    NavBar,
    Loader,
    SideNav,
    Footer
  },
  mounted() {
    $(document).ready(function() {
      $("#sideNavCollapse").on("hide.bs.collapse", function() {
        $("#navbarToggler").text("menu");
      });
      $("#sideNavCollapse").on("show.bs.collapse", function() {
        $("#navbarToggler").text("menu_open");
      });

      var topBtn = document.getElementById("topBtn");
      window.onscroll = function() {
        if (
          document.body.scrollTop > 20 ||
          document.documentElement.scrollTop > 20
        ) {
          topBtn.style.display = "block";
        } else {
          topBtn.style.display = "none";
        }
      };
    });
  },
  data() {
    return {
      isLoading: true
    };
  },
  methods: {
    goToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style lang="scss">
#topBtn {
  display: none;
  position: fixed;
  bottom: 2rem;
  right: 7rem;
  z-index: 99;
}

html,
body {
  height: 100%;
}

.hzPin {
  display: none !important;
}

.image-style-side {
  float: right;
}

.image img{
  width: 100%;
}

#app {
  font-family: "Geneva", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 100%;
  min-height: 100vh;
}

.app-body {
  width: 100%;
  flex: 1;
}

#app .pointer {
  cursor: pointer;
}

.loader-wheel {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

.modal-xxl {
  max-width: 1280px;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.modal-body {
  text-align: left;
}

#snackbar {
  visibility: hidden;
  min-width: 250px;
  margin-left: -125px;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  z-index: 1;
  left: 50%;
  top: 30px;
  font-size: 17px;
}

#snackbar.show {
  visibility: visible;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

#snackbar.long-show {
  visibility: visible;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 5.5s;
  animation: fadein 0.5s, fadeout 0.5s 5.5s;
}

@-webkit-keyframes fadein {
  from {
    top: 0;
    opacity: 0;
  }
  to {
    top: 30px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    top: 0;
    opacity: 0;
  }
  to {
    top: 30px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    top: 30px;
    opacity: 1;
  }
  to {
    top: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    top: 30px;
    opacity: 1;
  }
  to {
    top: 0;
    opacity: 0;
  }
}

.vuecal__cell--has-events {
  background-color: #17a2b855;
}
.vuecal__event.leisure {
  background-color: rgba(253, 156, 66, 0.9);
  border: 1px solid rgb(233, 136, 46);
  color: #fff;
}
.vuecal__cell.selected {
  background-color: #17a2b855;
}
.vuecal__cell.today {
  background-color: #17a2b855;
}
.vuecal__event-title {
  cursor: pointer;
}
.vuecal__title-bar {
  background-color: #17a2b855;
}

.new {
  background-color: #007bff55;
}

.started {
  background-color: #ffc10755;
}

.applied {
  background-color: #17a2b855;
}

.won {
  background-color: #28a74555;
}

.not-won {
  background-color: #dc354555;
}

.divider-right {
  border-right: 2px solid gray;
}

.indicator {
  width: 1rem;
  height: 1rem;
  border-radius: 1rem;
  background-color: cornflowerblue;
}

.light-background {
  background-color: #00000011;
}

.modal-xl {
  max-width: 875px;
}

.no-status {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 1.25rem;
  background-color: #bebebe55;
}

.awaiting-approval {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 1.25rem;
  background-color: #17a2b855;
}

.production {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 1.25rem;
  background-color: #28a74555;
}

.errored {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 1.25rem;
  background-color: #ffc10755;
}

.rejected {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 1.25rem;
  background-color: #dc354555;
}

.blacklisted {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 1.25rem;
  background-color: black;
}

.header-row {
  font-size: 1rem;
  font-weight: bold;
  background-color: lightgray;
}
</style>
